import { dataShrink } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShrink = /*#__PURE__*/createIcon(dataShrink)
export default IconShrink
